const Main = ($) => {
	function checkVisibility() {
		$('.fade-in, .single-post .col > *').each(function () {
			var elementTop = $(this).offset().top;
			var windowBottom = $(window).scrollTop() + $(window).height();
			if (elementTop < windowBottom - 50) {
				$(this).addClass('visible');
			}
		});
	};
	
	const headerHeight = $('header').height();
	$(document).on("scroll", function () {
		if ($(document).scrollTop() > headerHeight) {
			$("header").addClass("fixed-header");
			if($(window).width() > 1200){
				$('header .custom-logo').attr('src', '/wp-content/themes/cohere/assets/images/co.svg');
			}
		} else {
			$("header").removeClass("fixed-header");
			if($(window).width() > 1200){
				$('header .custom-logo').attr('src', '/wp-content/uploads/2025/11/logo.svg');
			}
		}
	});

	checkVisibility();
	$(window).scroll(checkVisibility);
	$('.burger-menu-button').click(function (e) {
		e.preventDefault();
		if ($(this).parents('.burger-menu').hasClass('open')) {
			$(this).parents('.burger-menu').removeClass('open');
			$(this).parent().find('p').text('MENU');
			$('header .menu').removeClass('open');
			$('body').removeClass('open-menu');
		} else {
			$(this).parents('.burger-menu').addClass('open');
			$(this).parents('.burger-menu').parent().find('p').text('CLOSE');
			$('header .menu').addClass('open');
			$('body').addClass('open-menu');
		}
	});

	const newsItemsSlide = $('.news-items:not(.grid-cohere), .project-items:not(.grid-cohere):not(.grid)');
	const projectSlide = $('.project-items.grid');
	if ($(window).width() < 768) {
		projectSlide.slick({
			infinite: true,
			slidesToShow: 1,
			arrows: true,
			dots: false,
			prevArrow: '<i class="slick-prev"></i>',
			nextArrow: '<i class="slick-next"></i>',
		});
		$('footer .custom-logo-link').append('<img class="co" src="/wp-content/themes/cohere/assets/images/co.svg">')
	}
	if (newsItemsSlide.length) {
		console.log(newsItemsSlide);
		newsItemsSlide.slick({
			infinite: true,
			slidesToShow: 4,
			slidesToScroll: 1,
			arrows: true,
			dots: false,
			prevArrow: '<i class="slick-prev"></i>',
			nextArrow: '<i class="slick-next"></i>',
			responsive: [
				{
					breakpoint: 1024,
					settings: {
						slidesToShow: 3,
					}
				},
				{
					breakpoint: 768,
					settings: {
						slidesToShow: 1,
					}
				}
			]
		});
	}

	const contactButton = $('.contacts');
	if (contactButton.length) {
		contactButton.click(function (e) {
			e.preventDefault();
			$('.contacts-block').toggleClass('active');
			$('body').toggleClass('open-contacts');
		});
	}

	const closeBotton = $('.close');
	if (closeBotton.length) {
		closeBotton.click(function (e) {
			$('.contacts-block').removeClass('active');
			$('body').toggleClass('open-contacts');
		});
	}


	if ($('.textarea textarea, .input input').length) {

		const textarea = $('.textarea textarea, .input:not(.tel) input');
		textarea.focus(function () {
			$(this).css('border-color', '#fff')
			$(this).parent().addClass('focus');
		});
		textarea.blur(function () {
			if ($(this).val().length === 0) {
				$(this).css('border-color', '#48413B');
				$(this).parent().removeClass('focus');
			}
		});

		textarea.each(function () {
			if ($(this).val().length === 0) {
				$(this).parent().removeClass('focus');
			} else {
				$(this).parent().addClass('focus');
			}
		});

		$('.input i').click(function () {
			if ($(this).hasClass('bi-eye')) {
				$(this).removeClass('bi-eye').addClass('bi-eye-slash');
				$(this).parent().find('input').attr('type', 'text');
			} else {
				$(this).removeClass('bi-eye-slash').addClass('bi-eye');
				$(this).parent().find('input').attr('type', 'password');
			}
		});
	}
};

export default (($) => $(Main))(jQuery);
